import { MenuItem } from './menu.model';

export const getMenu = (projectId) => {
    const menu: MenuItem[] = [
        {
            label: 'Account & Security',
            isTitle: true,
        },
        {
            label:'Profile',
            icon:'bx-user-circle',
            link: 'settings/profile'
        },
        {
            label: 'Entities',
            isTitle: true,
        },
        {
            label:'Companies',
            icon:'bx-building',
            link: 'settings/companies'
        },
        {
            label:'Billing Accounts',
            icon:'bx-credit-card',
            link: 'settings/billing-accounts'
        }, 
    ];

    return menu;
}

export let MENU: MenuItem[] = [
    {
        label: 'Account & Security',
        isTitle: true,
    },
    {
        label:'Profile',
        icon:'bx-user-circle',
        link: 'settings/profile'
    },
    {
        label: 'Entities',
        isTitle: true,
    },
    {
        label:'Companies',
        icon:'bx-building',
        link: 'settings/companies'
    },
    {
        label:'Billing Accounts',
        icon:'bx-credit-card',
        link: 'settings/billing-accounts'
    }, 
];

